// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_search-bar__J4\\+9U {
    min-width: 100px;
    width: 100%;
    height: 44px;
    font-size: 14px;
    font-weight: 450;
    border-radius: 5px;
    outline: none;
    border: none;
    padding: 5px 10px;
    background-color: var(--color-input-background);
    color: var(--color-main-typography)
}

.search_search-bar__J4\\+9U:focus {
    outline: none;
}

.search_search-bar-bordered__FDst2 {
    min-width: 100px;
    width: 100%;
    height: 44px;
    font-size: 14px;
    font-weight: 450;
    border-radius: 5px;
    outline: none;
    border: 1px solid var(--color-inactive-filter);
    padding: 5px 10px;
    background-color: var(--color-input-background);
    color: var(--color-main-typography)
}

.search_search-bar-bordered__FDst2:focus {
    outline: none;
}

.search_search-container__qLUvR {
    position: relative;
    width: 100%;
}

.search_search-button__4Xc1S {
    position: absolute;
    top: 10%;
    right: 5px;
    background-color: var(--color-content-sidebar);
    border-radius: 5px;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
}

.search_search-button-clear__Kd7CT {
    position: absolute;
    top: 10%;
    right: 5px;
    background: none;
    border-radius: 5px;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
}

@media screen and (max-width: 1000px) {
    .search_search-bar__J4\\+9U {
        min-width: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/search/search.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,+CAA+C;IAC/C;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,8CAA8C;IAC9C,iBAAiB;IACjB,+CAA+C;IAC/C;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".search-bar {\n    min-width: 100px;\n    width: 100%;\n    height: 44px;\n    font-size: 14px;\n    font-weight: 450;\n    border-radius: 5px;\n    outline: none;\n    border: none;\n    padding: 5px 10px;\n    background-color: var(--color-input-background);\n    color: var(--color-main-typography)\n}\n\n.search-bar:focus {\n    outline: none;\n}\n\n.search-bar-bordered {\n    min-width: 100px;\n    width: 100%;\n    height: 44px;\n    font-size: 14px;\n    font-weight: 450;\n    border-radius: 5px;\n    outline: none;\n    border: 1px solid var(--color-inactive-filter);\n    padding: 5px 10px;\n    background-color: var(--color-input-background);\n    color: var(--color-main-typography)\n}\n\n.search-bar-bordered:focus {\n    outline: none;\n}\n\n.search-container {\n    position: relative;\n    width: 100%;\n}\n\n.search-button {\n    position: absolute;\n    top: 10%;\n    right: 5px;\n    background-color: var(--color-content-sidebar);\n    border-radius: 5px;\n    width: 34px;\n    height: 34px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n}\n\n.search-button-clear {\n    position: absolute;\n    top: 10%;\n    right: 5px;\n    background: none;\n    border-radius: 5px;\n    width: 34px;\n    height: 34px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n}\n\n@media screen and (max-width: 1000px) {\n    .search-bar {\n        min-width: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-bar": `search_search-bar__J4+9U`,
	"search-bar-bordered": `search_search-bar-bordered__FDst2`,
	"search-container": `search_search-container__qLUvR`,
	"search-button": `search_search-button__4Xc1S`,
	"search-button-clear": `search_search-button-clear__Kd7CT`
};
export default ___CSS_LOADER_EXPORT___;
